// extracted by mini-css-extract-plugin
export var label = "_ek-2";
export var slideContainer = "_ek-0";
export var slider = "_ek-1";